import { useQuery, type UseQueryOptions } from '@pinia/colada'

export type TQueryWrapper<T = any> = typeof useQueryWrapper<T>
export type TQueryWrapperReturnType<T = any> = ReturnType<TQueryWrapper<T>>

export const useQueryWrapper = <T>(
  options: UseQueryOptions<T, any, T>,
  placeholder?: T,
  onError?: (error: any) => void) => {
  const query = useQuery<T, any, T>({
    ...options,
    placeholderData: placeholder
  })

  watch(query.error, (error) => {
    if (error) {
      if (onError) {
        return onError(error)
      }
    }
  })

  const isPending = computed(() => query.isPending.value || query.isPlaceholderData.value)
  const hasCompletedOnce = ref(false)

  watch(isPending, (val) => {
    if (!val) {
      setTimeout(() => {
        hasCompletedOnce.value = true
      })
    }
  }, { immediate: true })

  return {
    ...query,
    data: computed(() => query.data.value ?? placeholder),
    isPending,
    isRefetching: computed(() => hasCompletedOnce.value && query.asyncStatus.value === 'loading')
  }
}
